import { render, staticRenderFns } from "./outer.vue?vue&type=template&id=4f89e080&scoped=true&"
import script from "./outer.vue?vue&type=script&lang=js&"
export * from "./outer.vue?vue&type=script&lang=js&"
import style0 from "./outer.vue?vue&type=style&index=0&id=4f89e080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f89e080",
  null
  
)

export default component.exports